import React from 'react';
import { Field } from 'redux-form';

import Checkbox from 'components/Input/Checkbox';
import { FEATURES_TYPES } from 'constants/Global';

/**
 * Step Optional Features
 * @param {Object} values
 */
const OptionalFeatures = ({ values }) => (
    <div data-step-optional-features className="optional-features-container">
        {FEATURES_TYPES.filter((type) => type.group.indexOf(values._property_type) > -1).map(
            (type) => (
                <div key={type.id} className="row-container row-container--checkbox">
                    <div className="row-container__label row-container__label--large row-container__label--small">
                        <Field
                            name={type.id}
                            component={Checkbox}
                            id={type.id}
                            label={type.label}
                            sublabel={type.sublabel}
                        />
                    </div>
                    {type.subField && values[type.id] && (
                        <div className="row-container__field row-container__field--small row-container__field--checkbox">
                            {type.subField.component}
                        </div>
                    )}
                </div>
            ),
        )}
    </div>
);

OptionalFeatures.displayName = 'OptionalFeatures';

/**
 * OptionalFeatures Functional Component.
 */
export default OptionalFeatures;
